<template>
    <div class="detailspayment">
      <div v-if="isLoading">
          <half-circle-spinner
            :animation-duration="750"
            :size="100"
            color="#1D3354"
            class="mx-auto"
          />
      </div>
      <div v-else-if="!detail" class="_global__nodata d-flex justify-content-center">
          <div class="text-center">
            <img src="@/assets/image/icon/nodata-payment.svg" alt="">
            <h6 class="pt-2">You have no details payment </h6>
          </div>
        </div>
      <div v-else class="detailspayment__content">
        <div class="contentheader">
          <div class="contentheader__status" :class="!detail.is_paid && !detail.id_payment ? 'contentheader__status--unpaid'
                  : 'contentheader__status--complete'">
            <span>
              {{ (!detail.is_paid && !detail.id_payment) ? 'Unpaid' : 'Completed'}}
            </span>
          </div>
          <p v-if="parseInt(detail.t_shipment.status_shipment) === 0">Instant Price</p>
          <p v-else-if="parseInt(detail.t_shipment.status_shipment) === 1">RFQ</p>
          <p v-else-if="parseInt(detail.t_shipment.status_shipment) === 2">Contract</p>
          <p><b>Invoice Number:</b> {{detail.invoice_number}}</p>
          <h5>{{ detail.t_shipment.origin_city }} [{{ detail.t_shipment.origin_country_code }}] to {{ detail.t_shipment.destination_city }} [{{ detail.t_shipment.destination_country_code}}]</h5>
          <p>Payment Due Date: {{getDate(detail.due_date)}} </p>
        </div>

        <div class="contentbody">
          <h6>Shipment Details</h6>
          <div class="row m-0">
              <div class="col-md-6 pl-0">
                <div class="row m-0">
                  <div class="col-md-3 p-0">Company Name</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0">{{ detail.t_shipment.c_user.c_comp.compname }}</div>
                </div>
                <div class="row m-0">
                  <div class="col-md-3 p-0">Order Number</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0">{{ detail.order_number }}</div>
                </div>
                <div class="row m-0 mb-2">
                  <div class="col-md-3 p-0"
                      v-if="parseInt(detail.t_shipment.status_shipment) === 1">RFQ Number</div>
                  <div class="col-md-3 p-0"
                      v-else-if="parseInt(detail.t_shipment.status_shipment) === 2">Contract Number</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0" v-if="(parseInt(detail.t_shipment.status_shipment) === 1 || parseInt(detail.t_shipment.status_shipment) === 2)">
                    {{ detail.t_shipment.reference_number }}
                  </div>
                  <div v-else>-</div>
                </div>

                <div class="row m-0">
                  <div class="col-md-3 p-0">Freight Mode</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0">{{ getFreigtMode(detail.t_shipment.freight_mode) }}</div>
                </div>
                <div class="row m-0">
                  <div class="col-md-3 p-0">Shipment Type</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0">{{ getShipmentType(detail.t_shipment.freight_type.replace(/SEA/g,'')) }}</div>
                </div>
                <div class="row m-0">
                  <div class="col-md-3 p-0">Shipment Service</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0">{{ getOptionTp(detail.t_shipment.shipment) }}</div>
                </div>
                <div class="row m-0">
                  <div class="col-md-3 p-0">Term of Payment</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0">{{ detail.t_shipment.termofpayment }} days</div>
                </div>
                <div class="row m-0">
                  <div class="col-md-3 p-0">Value of Goods</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0">{{ detail.t_shipment.value_of_goods ? detail.t_shipment.value_of_goods.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","): 0 }}</div>
                </div>
              </div>

              <div class="col-md pr-0">
                <div class="row m-0">
                  <div class="col-md-4 p-0">HS Code</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0">{{ detail.t_shipment.commodities_hscode }}</div>
                </div>
                <div class="row m-0">
                  <div class="col-md-4 p-0">Product Type</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0">{{ getProductType(detail.t_shipment.commodities_class) }}</div>
                </div>
                <div class="row m-0">
                  <div class="col-md-4 p-0">Kind of Goods</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0">
                    {{detail.t_shipment.commodities_type ? detail.t_shipment.commodities_type : '-'}}
                  </div>
                </div>
                <div class="row m-0">
                  <div class="col-md-4 p-0">Product Description</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0">
                  {{ detail.t_shipment.commodities_product }}
                  </div>
                </div>
                <div class="row m-0">
                  <div class="col-md-4 p-0">Additional Services</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0"
                      v-if="parseInt(detail.t_shipment.insurance_stat) || parseInt(detail.t_shipment.custom_origin_stat !== 0) || parseInt(detail.t_shipment.custom_destination_stat !== 0)">
                  {{ parseInt(detail.t_shipment.insurance_stat) === 0 ? '' : 'Insurance' }}
                  {{ parseInt(detail.t_shipment.custom_origin_stat) === 0 ? '' : ', Custom Clearance (Origin)' }}
                  {{ detail.t_shipment.custom_destination_stat ? ', Custom Clearance (Destination)' : '' }}
                  </div>
                  <div class="col-md p-0" v-else>-</div>
                </div>
                <div class="row m-0">
                  <div class="col-md-4 p-0">Remarks</div>
                  <div class="col-md-0 px-1">:</div>
                  <div class="col-md p-0">
                  {{ detail.t_shipment.shipper_notes ? detail.t_shipment.shipper_notes : '-' }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="!isLoading && detail" class="mt-4">
              <StatusUnpaid :statusShipment="detail.t_shipment.status_shipment" ></StatusUnpaid>
            </div>

            <div class="mt-4 text-center">
              <router-link tag="button" :to="{ name: 'Payment' }" class="button__bluecorporite">
                Go to Payment
              </router-link>
            </div>

        </div>

      </div>
    </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
import StatusUnpaid from '@/components/payment/paymentStatus/StatusUnpaid'
import { mapGetters } from 'vuex'
import * as moment from 'moment'

export default {
  name: 'DetailsPayment',
  components: {
    StatusUnpaid,
    HalfCircleSpinner
  },
  computed: {
    ...mapGetters({
      detail: 'payment/item',
      isLoading: 'payment/isLoading',
      isError: 'payment/error'
    })
  },
  methods: {
    getFreigtMode (mode) {
      if (mode === 'OCEAN') { return 'Ocean' }
      if (mode === 'AIR') { return 'Air' }
    },
    getProductType (type) {
      if (type === 'GENCO') { return 'General Cargo' }
      if (type === 'SC') { return 'Special Cargo' }
      if (type === 'DG') { return 'Dangerous Goods' }
    },
    getShipmentType (type) {
      if (type === 'AIRCARGO' || type === 'aircargo') {
        const newType = type.replace(type, 'Air Cargo')
        return newType
      } else if (type === 'AIRCOURIER' || type === 'aircourier') {
        const newType = type.replace(type, 'Air Courier')
        return newType
      } else if (type === 'fcl') {
        return 'FCL'
      } else {
        if (type !== 'LCL') { return type } else { return 'LCL' }
      }
    },
    manageShipment: function () {
      this.$router.push({ path: '/manage-shipment' })
    },
    fetchShipmentDetail () {
      const idInvoice = this.$route.params.idInvoice
      const type = this.$route.params.type
      this.$store.dispatch('payment/FETCH_INVOICE_DETAIL', {idInvoice, type})
    },
    getOptionTp (type) {
      let optionTp = '-'
      switch (type) {
        case 'ptp' : optionTp = 'Port to Port'
          break
        case 'dtp' : optionTp = 'Door to Port'
          break
        case 'dtd' : optionTp = 'Door to Door'
          break
        case 'ptd' : optionTp = 'Port to Door'
          break
        default : optionTp = '-'
        /* eslint-disable-next-line */
      }
      /* eslint-disable-next-line */
      return optionTp
      /* eslint-disable-next-line */
    },
    getDate (date) {
      return moment(date).format('DD MMM YYYY')
    }
  },
  mounted () {
    this.fetchShipmentDetail()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payment/paymentStatus/DetailsPayment.vue